import React from 'react';
import set from 'lodash/set';
import get from 'lodash/get';
import {
  CLIENT_WEB_TO_EMBEDDER_MESSAGE_POST_METHOD_NAME,
  ClientWebEmbeddingMessage,
  EMBEDDER_TO_CLIENT_WEB_MESSAGE_POST_METHOD_NAME,
} from '@youhelp-ru/common/clientWebEmbedding';
import { EmbeddingContext } from 'src/shared/embedding';
import { EmbeddingIntegrationProviderProps } from './types';
import { useEmbeddingMessages } from './model';

export const EmbeddingIntegrationProvider: React.FC<React.PropsWithChildren<EmbeddingIntegrationProviderProps>> = ({ children }) => {
  const [isInited, setInited] = React.useState(false);

  const postMessage = React.useCallback((message: ClientWebEmbeddingMessage) => {
    if (typeof window === 'undefined') {
      return;
    }

    // NOTE: When constant `CLIENT_WEB_TO_EMBEDDER_MESSAGE_POST_METHOD_NAME` is used, it leads to exception:
    // `Java bridge method can't be invoked on a non-injected object`
    // https://github.com/react-native-webview/react-native-webview/issues/323#issuecomment-511824940
    window.ReactNativeWebView?.postMessage?.(JSON.stringify(message));

    // TODO: Refactor to use constant without exception throwing
    // (get(window, CLIENT_WEB_TO_EMBEDDER_MESSAGE_POST_METHOD_NAME) as unknown as ((msg: string) => void) | undefined)?.(
    //   JSON.stringify(message),
    // );
  }, []);

  const handleMessage = useEmbeddingMessages({ isInited, postMessage });

  React.useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    set(window, EMBEDDER_TO_CLIENT_WEB_MESSAGE_POST_METHOD_NAME, (msg: string) => {
      const message = JSON.parse(msg);
      handleMessage(message);
    });

    setInited(true);
  }, [handleMessage]);

   
  return <EmbeddingContext.Provider value={React.useMemo(() => ({ postMessage }), [postMessage])}>{children}</EmbeddingContext.Provider>;
};
